// @flow
import { connect } from 'react-redux';

import RencontreTeam, { type StateProps } from 'components/rencontre/general/RencontreTeam';

import type { StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  rencontre: state.rencontreState.rencontre,
  placeholder: state.settingsState.placeholder,
});

export default connect(mapStateToProps)(RencontreTeam);
